import { FC, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Earth } from 'TaxAnalyticsImages';
import { tag } from 'TaxAnalyticsHelpers/ATInternet';
import { useLocation } from 'react-router';
const Reply: FC = (props) => {
    const location = useLocation();
    useEffect(() => {
        tag.sendPage({
            name: "Auth - Reply"
        });
    }, [location.pathname]);
    return (
        <Grid container spacing={6}>
            <Grid component="section" id="landing">
                <Grid container direction="row" justifyContent="space-around" alignItems="center">
                    <Grid xs={12} sm={5}>
                        <CircularProgress size={64} />
                    </Grid>
                    <Grid xs={12} sm={7}>
                        <img src={Earth} style={{ maxWidth: '100%', opacity: '0.75' }} alt="CyberEarthLogo" />
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    );
}

export default Reply